import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { CONVERSIONCHART_INIT_LOADING, CONVERSIONCHART_INIT_SUCCESS, CONVERSIONCHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  conversionChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initConversionChart({ commit, state }, data) {
    commit(CONVERSIONCHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.conversionChart
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to),
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          chartInfo: result.data.chartInfo,
          appIds: result.data.appIds
        })
        commit(CONVERSIONCHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(CONVERSIONCHART_INIT_FAIL)
      }
    } else {
      commit(CONVERSIONCHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [CONVERSIONCHART_INIT_LOADING](state) {
    state.conversionChart.init = 0
  },
  [CONVERSIONCHART_INIT_SUCCESS](state, data) {
    const { conversionChart } = state
    conversionChart.menu = data.menu
    conversionChart.init = 1
    conversionChart.lastUpdated = new Date()
    conversionChart.scope = data.scope
    conversionChart.appId = data.appId
    conversionChart.info = data.info
    conversionChart.appIds = data.appIds
    Vue.set(conversionChart, 'chartInfo', data.chartInfo)
  },
  [CONVERSIONCHART_INIT_FAIL](state) {
    state.conversionChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
